'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { setPrimaryTracker } from 'usage-tracker-container';
import Raven from 'raven-js';
import dataFetchingClient from './utils/DataFetchingClient';
import { DataFetchingClientProvider } from 'academy-common-lib/utils/DataFetchingClient';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import Routes from './routes';
import { configureStore } from './utils/configureStore';
import UsageTracker from './utils/UsageTracker';
import { handleInternalReferral } from './utils/RoutingUtils';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import NativeBackButton from './components/Layouts/NativeBackButton';
import { Navbar } from './features/navbar';
import ErrorBoundary from './components/Errors/ErrorBoundary';
import { ThemeProvider } from 'academy-common-lib/utils/Styling';
import { PlaylistSurvey } from './features/savedItems/components/PlaylistSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACADEMY_IFRAME_INITIATED = 'academy-iframe-initiated';
if (window.self !== window.top) {
  window.parent.postMessage(ACADEMY_IFRAME_INITIATED, window.location.origin);
}
export default class LearningCenter extends Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidMount() {
    setPrimaryTracker(UsageTracker.tracker);
    this.handlePossibleReferral();
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: errorInfo
    });
  }
  handlePossibleReferral() {
    handleInternalReferral({
      href: window.location.href,
      sendTracking: data => {
        UsageTracker.track('interaction', Object.assign({
          action: 'internal-referral'
        }, data));
      },
      replacePath: newPath => window.history.replaceState(null, '', newPath)
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/_jsx(ACBadRequestError, {});
    }
    const {
      gates,
      portalId,
      scopes,
      user
    } = this.props;
    const email = user.email || user.emails && user.emails[0];
    const store = configureStore({
      auth: {
        user: {
          user_id: user.id,
          email,
          firstName: user.firstName,
          lastName: user.lastName,
          verifiedAt: user.verifiedAt,
          locale: user.locale,
          langEnabled: user.languageEnabled
        },
        portal: {
          portal_id: portalId
        },
        gates,
        scopes
      }
    });
    return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(ThemeProvider, {
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(Provider, {
            store: store,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs(Router, {
                basename: `/academy/${portalId}`,
                children: [/*#__PURE__*/_jsx(Navbar, {}), /*#__PURE__*/_jsx(PlaylistSurvey, {}), /*#__PURE__*/_jsxs(ErrorBoundary, {
                  children: [/*#__PURE__*/_jsx(NativeBackButton, {}), /*#__PURE__*/_jsx(Route, {
                    children: ({
                      history
                    }) => /*#__PURE__*/_jsx(RhumbProvider, {
                      config: rhumbConfig,
                      history: historyAdapter(history),
                      children: /*#__PURE__*/_jsx(Routes, {})
                    })
                  })]
                })]
              })
            })
          })]
        })
      })
    });
  }
}
LearningCenter.propTypes = {
  gates: PropTypes.array.isRequired,
  portalId: PropTypes.number.isRequired,
  scopes: PropTypes.array,
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    emails: PropTypes.array,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    verifiedAt: PropTypes.number,
    locale: PropTypes.string,
    languageEnabled: PropTypes.bool
  }).isRequired
};